import { useEffect, useState } from 'react';

export const useKeyboardStatus = (isMobile: boolean): boolean => {
  const [isKeyboardOpen, setIsKeyboardOpen] = useState(false);

  useEffect(() => {
    if (!isMobile) {
      setIsKeyboardOpen(false);
      return;
    }

    document.addEventListener(
      'focus',
      (event) => {
        // TODO: Later we can add or remove some conditions
        if (
          event.target instanceof HTMLInputElement ||
          event.target instanceof HTMLTextAreaElement
        ) {
          setIsKeyboardOpen(true);
        } else setIsKeyboardOpen(false);
      },
      true, // Use capturing mode
    );

    document.addEventListener(
      'blur',
      () => {
        setIsKeyboardOpen(false);
      },
      true, // Use capturing mode
    );
  }, [isMobile]);

  return isKeyboardOpen;
};
